import { render, staticRenderFns } from "./regionGrowCourse.vue?vue&type=template&id=76ebba97&scoped=true"
import script from "./regionGrowCourse.vue?vue&type=script&lang=js"
export * from "./regionGrowCourse.vue?vue&type=script&lang=js"
import style0 from "./regionGrowCourse.vue?vue&type=style&index=0&id=76ebba97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ebba97",
  null
  
)

export default component.exports